module.exports = __webpack_public_path__ + "static/media/alliance_logo.c0b4eb27.jpeg";